
const _resourceLibraryIgnore =
	[
		'aftermarket',
		'connectivity',
		'detroit emobility',
		'finance and insurance',
		'other',
		'powertrain',
		'safety'
	];

const _wordExceptions = {
	'child': 'children',
	'criterion': 'criteria',
	'deer': 'deer',
	'foot': 'feet',
	'goose': 'geese',
	'man': 'men',
	'mouse': 'mice',
	'person': 'people',
	'phenomenon': 'phenomena',
	'series': 'series',
	'species': 'species',
	'sheep': 'shee',
	'tooth': 'teeth',
	'woman': 'women',		
};


export function getPluralForm(name) {

	if (!name || typeof name !== 'string')
		name = '';

	if (name.length > 3) {

		const compare = name.toLowerCase();

		const lastIndex = compare.length - 1;

		const lastLetter = compare[lastIndex];

		const lastTwoLetters = compare.substring(compare.length - 2, compare.length);

		if (_wordExceptions[compare]) {

			const newWord = _wordExceptions[compare];

			name = `${name.substring(0, 1)}${newWord.substring(1, newWord.length)}`;

        } else if (lastLetter === 's'
			|| lastLetter === 'x'
			|| lastLetter == 'z'
			|| lastTwoLetters === 'ss'
			|| lastTwoLetters == 'sh'
			|| lastTwoLetters == 'ch') {

			name = `${name}es`;

		} else if ((lastTwoLetters === 'fe' || lastLetter === 'f')
			&& compare !== 'roof' && compare !== 'belief' && compare !== 'chef' && compare !== 'chief') {

			name = lastTwoLetters === 'fe'
				? `${name.substring(0, name.length - 1)}ves`
				: `${name.substring(0, lastIndex)}ves`;
		}

		else if (lastLetter === 'y'
			&& lastTwoLetters !== 'ay'
			&& lastTwoLetters !== 'ey'
			&& lastTwoLetters != 'iy'
			&& lastTwoLetters !== 'oy'
			&& lastTwoLetters != 'uy') {

			name = `${name.substring(0, lastIndex)}ies`;

		} else if (lastLetter === 'o'
			&& compare !== 'piano'
			&& compare !== 'halo'
			&& compare !== 'photo') {

			name = `${name}es`;

		} else if (lastTwoLetters === 'us') {

			name = `${name.substring(0, name.length - 2)}i`;

		} else if (lastTwoLetters === 'is') {

			name = `${name.substring(0, name.length - 2)}es`;

		} else {

			name = `${name}s`;
		}

		return name;
	}
}

export function ignoreResourceLibraryWord(word) {

	const ignore = _resourceLibraryIgnore.find((x) => word?.toLowerCase() === x);

	return ignore !== undefined;
}